/*
 * @Author: fz
 * @Date: 2021-07-13 14:53:25
 * @LastEditTime: 2021-07-28 18:09:33
 * @LastEditors: Please set LastEditors
 * @Description: 发车规则 api
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const { host = "", E6_MS_TMS_BUSI_WEB = "" } = e6ModuleOrderWaybillProcessApi;

//获取表格数据
export function getdepartureList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/departureRule/pageQueryDepartureRule`,
    method: "post",
    data
  });
}
//删除
export function DeletedetailInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/departureRule/deleteRule`,
    method: "post",
    data
  });
}
//获取历史表格数据
export function getdepartureHistoryList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/departureRule/pageQueryDepartureRuleHistory`,
    method: "post",
    data
  });
}
//校验数据
export function existRule(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/departureRule/checkRule`,
    method: "post",
    data
  });
}

//新增/修改发车规则保存
export function saveDepartureRules(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/departureRule/saveOrUpdateRule`,
    method: "post",
    data
  });
}

//查询发车规则详细信息
export function getDepartureRulesById(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/departureRule/queryByRuleId`,
    method: "get",
    params
  });
}

//发车规则名称唯一性校验
export function existRuleName(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/departureRule/validateRuleName`,
    method: "get",
    params
  });
}
